import { Component, input } from '@angular/core';
import { IconTheme } from '../../../../hot-toast.model';

@Component({
  selector: 'hot-toast-info',
  templateUrl: './info.component.html',
})
export class InfoComponent {
  readonly theme = input<IconTheme>();
}
